// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  background: #fff !important;
}

ion-card.contentcard {
  background: #fff !important;
}
ion-card.contentcard .toolbarcontainer {
  background: #fff !important;
  margin: 0;
  position: relative;
  display: flex;
  padding: 2vw;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
ion-card.contentcard .toolbarcontainer ion-buttons {
  position: absolute;
  background-color: var(--ion-color-medium);
  color: var(--ion-white-primary);
  border-radius: 20px;
  top: 14px;
  left: 12px;
  padding: 4px;
}
ion-card.contentcard .toolbarcontainer img {
  border-radius: 20px;
  width: 60vw;
  max-height: 60vw;
  border: 0px dashed #d2d2d2;
}
ion-card.contentcard ion-card {
  box-shadow: none;
}
ion-card.contentcard ion-card ion-card-header {
  padding: 5px 0;
}
ion-card.contentcard ion-card ion-label.name-header {
  text-align: center;
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
}
ion-card.contentcard ion-card ion-label.name-header h3 {
  font-size: 16px;
  color: var(--ion-color-primary);
  font-weight: 400;
}
ion-card.contentcard ion-card ion-label.name-header ion-icon[name=star] {
  vertical-align: sub;
}
ion-card.contentcard ion-card ion-label.name-header ion-note {
  margin: 0 5px;
  font-size: 12px;
}
ion-card.contentcard ion-card ion-label.recipes {
  text-align: center;
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
}
ion-card.contentcard ion-card ion-label.recipes span {
  border: 1px dashed #ccc;
  border-radius: 6px;
  padding: 3px;
}

ion-label.name-macro {
  text-align: center;
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
ion-label.name-macro span {
  border: 0px;
  border-style: solid;
  border-radius: 10px;
  --border-radius: 10px;
  background: var(--ion-diffuseLight-primary);
  color: var(--ion-color-tertiary);
  padding: 1px 5px;
  width: 20vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
}

.appBtnIcon {
  height: 5vw;
  max-width: 5vw;
  min-width: 5vw;
  margin: 0vw;
  font-size: 16px;
}

.submitIcon {
  color: var(--ion-bright-success);
}

.closeIcon {
  color: var(--ion-bright-danger);
}

.appBtn {
  display: flex;
  flex-direction: row;
  gap: 2vw;
  margin: 0vw;
  padding: 1vw 3vw;
  width: 100%;
  height: 12vw;
  font-size: 16px;
  letter-spacing: 1px;
  justify-content: space-evenly;
  align-items: center;
}

.modalFooter {
  display: flex;
  margin: 0;
  padding: 4vw;
  flex-direction: row-reverse;
  gap: 4vw;
  align-items: center;
  justify-content: space-between;
  background: var(--ion-lighter-primary);
  --background: var(--ion-white-primary);
}

.invBoxC {
  display: flex;
  flex-direction: column;
  gap: 2vw;
  margin: 2vw;
}`, "",{"version":3,"sources":["webpack://./src/app/menu/menu-detail/menu-detail.page.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;AACJ;;AAGA;EACI,2BAAA;AAAJ;AACI;EACI,2BAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EAEA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AACQ;EACI,kBAAA;EACA,yCAAA;EACA,+BAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AACZ;AAEQ;EACI,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;AAAZ;AAGI;EACI,gBAAA;AADR;AAGQ;EACI,cAAA;AADZ;AAIQ;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;AAFZ;AAIY;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;AAFhB;AAKY;EACI,mBAAA;AAHhB;AAMY;EACI,aAAA;EACA,eAAA;AAJhB;AAUQ;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;AARZ;AAUY;EACI,uBAAA;EACA,kBAAA;EACA,YAAA;AARhB;;AAcA;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAXJ;AAaI;EACI,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,2CAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AAXR;;AAwCA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AArCF;;AAwCA;EAEE,gCAAA;AAtCF;;AAwCA;EACC,+BAAA;AArCD;;AAuCA;EACI,aAAA;EAEA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACH,YAAA;EACG,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AArCJ;;AAwCA;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,sCAAA;AArCF;;AAwCA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AArCJ","sourcesContent":["ion-header {\n    background: #fff !important;\n   \n}\n\nion-card.contentcard {\n    background: #fff !important;\n    .toolbarcontainer {\n        background: #fff !important;\n        margin: 0;\n        position: relative;\n        display: flex\n    ;\n        padding: 2vw;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        ion-buttons {\n            position: absolute;\n            background-color: var(--ion-color-medium);\n            color: var(--ion-white-primary);\n            border-radius: 20px;\n            top: 14px;\n            left: 12px;\n            padding: 4px;\n        }\n\n        img {\n            border-radius: 20px;\n            width: 60vw;\n            max-height: 60vw;\n            border: 0px dashed #d2d2d2;\n        }\n    }\n    ion-card {\n        box-shadow: none;\n\n        ion-card-header {\n            padding: 5px 0;\n        }\n\n        ion-label.name-header {\n            text-align: center;\n            display: flex;\n            gap: 10px;\n            justify-content: center;\n            flex-direction: column;\n            align-items: flex-start;\n\n            h3 {\n                font-size: 16px;\n                color: var(--ion-color-primary);\n                font-weight: 400;\n            }\n\n            ion-icon[name=\"star\"] {\n                vertical-align: sub;\n            }\n\n            ion-note {\n                margin: 0 5px;\n                font-size: 12px;\n            }\n\n\n        }\n\n        ion-label.recipes {\n            text-align: center;\n            display: grid;\n            gap: 10px;\n            grid-template-columns: 1fr 1fr;\n\n            span {\n                border: 1px dashed #ccc;\n                border-radius: 6px;\n                padding: 3px;\n            }\n        }\n    }\n}\n\nion-label.name-macro {\n    text-align: center;\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n    flex-direction: column;\n    align-items:center;\n\n    span {\n        border: 0px;\n        border-style: solid;\n        border-radius: 10px;\n        --border-radius: 10px;\n        background: var(--ion-diffuseLight-primary);\n        color: var(--ion-color-tertiary);\n        padding: 1px 5px;\n        width: 20vw;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        text-transform: capitalize;\n    }\n}\n\n// ion-footer {\n//     background: #fff !important;\n//     ion-toolbar {\n//         margin: 0;\n//         padding: 0;\n//         --padding-end: 5px;\n//         --padding-start: 5px;\n//         --padding-bottom: 5px;\n//         --padding-top: 5px;\n//         ion-button {\n//             margin: 16px;\n//             margin: 0px;\n//             max-height: 8vw;\n//             width: 40%;\n//             position: relative;\n//             font-size: 16px;\n//             --border-radius: 14px;\n//             --background: var(--ion-color-primary);\n//             --background-activated: var(--ion-color-secondary);\n//         }\n//     }\n// }\n\n\n\n.appBtnIcon {\n  height: 5vw;\n  max-width: 5vw;\n  min-width: 5vw;\n  margin: 0vw;\n  font-size: 16px;\n \n}\n.submitIcon{\n  // stroke: var(--ion-color-success);\n  color: var(--ion-bright-success);\n}\n.closeIcon{\n\tcolor: var(--ion-bright-danger);\n}\n.appBtn{\n    display: flex\n;\n    flex-direction: row;\n    gap: 2vw;\n    margin: 0vw;\n    padding: 1vw 3vw;\n    width: 100%;\n\theight: 12vw;\n    font-size: 16px;\n    letter-spacing: 1px;\n    justify-content: space-evenly;\n    align-items: center;\n    // color: var(--ion-text-primary);\n}\n.modalFooter {\n  display: flex;\n  margin: 0;\n  padding: 4vw;\n  flex-direction: row-reverse;\n  gap: 4vw;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--ion-lighter-primary);\n  --background: var(--ion-white-primary);\n}\n\n.invBoxC{\n    display: flex;\n    flex-direction: column;\n    gap: 2vw;\n    margin: 2vw;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
